import React, {useEffect, useState} from 'react';
import Dialog from "components/Dialog";
import {makeStyles, Typography} from "@material-ui/core";
import Tr from "translations/Translations";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import Loading from "components/Loading";
import moment from 'moment';
import MoreButton from "components/button/MoreButton";
import DateFormats from "constants/DateFormats";
import SingleButton from "components/popup/components/SingleButton";
import PropTypes from 'prop-types';
import useSearch from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";

const useStyle = makeStyles((theme) => ({
    buttonRow: {
        marginTop: theme.spacing(2),
        textAlign: "end"
    },
    lpColumn: theme.components.table.lpColumn,
    ipColumn: theme.components.table.ipColumn,
    dateColumn: theme.components.table.dateColumn
}));

export const createDownloadHistoryFile = (fileName, demandId, fileId) => ({fileName, demandId, fileId})

const DownloadHistoryPopup = (
    {
        downloadHistoryFile,
        service,
        onClose
    }) => {

    const classes = useStyle({});

    const [downloadHistory, setDownloadHistory] = useState(null);
    const [historyLoading, setHistoryLoading] = useState(false);
    const {searchData, totalCount, setTotalCount, setPaginationConfig} = useSearch();

    useEffect(() => {
        setHistoryLoading(true);
        const {pagination} = searchData;
        service.getDownloadHistory(downloadHistoryFile.demandId, downloadHistoryFile.fileId, pagination).then(handleHistoryLoad);
        // eslint-disable-next-line
    }, [searchData, downloadHistoryFile])

    useDidUpdateEffect(() => {
        if (downloadHistory?.totalCount !== undefined) {
            setTotalCount(downloadHistory.totalCount)
        }
    }, [downloadHistory?.totalCount]);


    const handleHistoryLoad = (resp) => {
        if (resp.paginator.page > 1) {
            setDownloadHistory((curState) => {
                return {
                    ...resp,
                    items: [...curState.items, ...resp.items]
                }
            });
        } else {
            setDownloadHistory(resp);
        }
        setHistoryLoading(false);
    }

    return (
        <Dialog
            title={Tr('download_history_details')}
            open
            titleCentered
            maxWidth={'md'}
            fullWidth={true}
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={Tr('close')}
                onClick={onClose}
            />}
        >

            {!downloadHistory && <Loading/>}

            {downloadHistory && <>
                <Typography>
                    {downloadHistoryFile.fileName}
                </Typography>
                <Typography>
                    {Tr('download_count_x', {downloadCount: downloadHistory.contractorTotalCount})}
                </Typography>
                <SimpleTable
                    columnClasses={[
                        classes.lpColumn,
                        undefined,
                        classes.ipColumn,
                        classes.dateColumn,
                    ]}
                    headers={[Tr('column_lp'), Tr('user_data'), Tr('ip_address'), Tr('download_date')]}
                    items={downloadHistory.items.map((item, index) => [
                        (index + 1),
                        item.downloadUserFullName === 'download.history.list.notloggeduser' ? Tr(item.downloadUserFullName) : item.downloadUserFullName,
                        item.ipAddress,
                        item.downloadDate ? moment(item.downloadDate).format(DateFormats.DATETIME_FORMAT) : ''
                    ])}
                />

                {historyLoading && <Loading/>}
                <MoreButton
                    config={searchData.pagination}
                    setConfig={setPaginationConfig}
                    totalCount={totalCount}
                    loadedCount={downloadHistory.items.length}
                    disabled={historyLoading}
                />

            </>}
        </Dialog>
    );
}


DownloadHistoryPopup.propTypes = {
    downloadHistoryFile: PropTypes.shape({
        fileName: PropTypes.string.isRequired,
        demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        fileId: PropTypes.oneOfType([PropTypes.number, PropTypes.object]).isRequired
    }),
    service: PropTypes.shape({
        getDownloadHistory: PropTypes.func.isRequired
    }),
    onClose: PropTypes.func.isRequired
};

export default DownloadHistoryPopup;